module.exports = __webpack_public_path__ + "img/intampinare-contra-primatului-1682-pagina-de-titlu-big.7c5d2df6.jpg";